<template>
    <div class="mt-3">
        <UserProfileInputs v-bind.sync="user" />
        <v-button aria-hidden="true" tabindex="2" @click="saveProfileChanges">
            <fa-icon :icon="['fas', 'user-check']" /> Save Profile Changes
        </v-button>
    </div>
</template>

<script>
import UserProfileInputs from './UserProfileInputs';

export default {
    components: { UserProfileInputs },
    props: {
        userId: { type: Number, required: true },
    },

    data() {
        return {
            user: {},
            realmRoles: [],
            realmRoleOptions: {},
            userRoleOptions: {},
        };
    },

    async created() {
        this.user = await this.$store.dispatch('auth/getUserInfo', this.userId);
    },

    methods: {
        saveProfileChanges() {
            this.$store.dispatch('auth/updateUserInfo', this.user);
        },
    },
};
</script>
